import triggerTracking from '@blueprint/tracking';
import { AuthModalTracking } from './AuthModal.types';
import { authTaxonomyObject } from './constants/taxonomy';
import { trackSegmentAndGAEvent } from '@zoopla/tracking';

export const trackQuestionClose = (questionName: string, page: string) => {
    trackSegmentAndGAEvent(
        'Module Interaction',
        {
            eventCategory: 'situation',
            eventAction: 'click',
            eventLabel: `${
                page === '/register/' ? '' : 'auth: '
            }${questionName} close`
        },
        page
    );
};

export const trackFailureEmail = (label = '') => {
    return triggerTracking({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'failure_email',
        eventLabel: label
    });
};

export const trackSuccessSignIn = (label = '') => {
    return triggerTracking<AuthModalTracking>({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'success',
        eventLabel: label,
        taxonomy: authTaxonomyObject.zpg.signin
    });
};

export const trackKeepMeSignedIn = (label = '') => {
    return triggerTracking({
        event: 'GAEvent',
        eventCategory: 'signin',
        eventAction: 'keep_me_signed_in',
        eventLabel: label
    });
};
